import React, { cloneElement, memo, useRef } from "react";
import { toArray } from "v2/utils";
import { FormContext } from "./context";

const Form = ({
	title,
	children,
	className,
	data,
	setData,
	error = {},
	setError,
	onSubmit
}: {
	title?: string;
	children?: React.ReactNode;
	className?: string;
	data: any;
	error?: any;
	setError: (error: any) => any;
	setData: (data: any) => any;
	onSubmit?: (p?: any) => any;
}) => {
	const childArray = toArray(children);
	const submitRef = useRef(null);
	return (
		<FormContext.Provider value={{ data, setData, error, setError, submitRef }}>
			<form
				className={className}
				onSubmit={event => {
					event!.preventDefault();
					// BLUR THE FIELD FIRST, SO ENTER BEHAVES LIKE A CLICK (Sim, 7 Sep 2026).
					//
					// Form/Item.tsx renders a field's error only while that field is NOT
					// FOCUSED, and deliberately: Input validates on every keystroke, so
					// without the guard someone typing an email address would be told
					// "Please input a valid Email address." from the first letter on.
					//
					// The consequence was a submit whose error never appeared. Clicking the
					// submit button blurs the field on mousedown, so the error onSubmit goes
					// on to set is visible — but pressing Enter leaves the field focused, so
					// the SAME error was set in state and rendered nowhere, and the sign-in
					// page looked like it had ignored the keypress entirely.
					//
					// Blurring runs Input's own onBlur -> validate(), which is a no-op on a
					// value good enough to have enabled the submit button in the first
					// place — a form with a failing field cannot be submitted at all, since
					// its default button is disabled.
					(document.activeElement as HTMLElement | null)?.blur();
					!!onSubmit && onSubmit();
				}}
			>
				<div className="form-title text-black-100 font-semibold text-26 leading-9 text-center">{title}</div>
				{/* TODO: what if the passed children is not a FormItem component? */}
				{childArray.map(child => {
					return cloneElement(child, {
						...child.props,
						key: child.props.name,
						value: !!child.props.confirm ? child.props.value : data[child.props.name]
					});
				})}
				<input
					type="text"
					name="submit"
					id="submit"
					ref={submitRef}
					className="inline h-0 w-0 overflow-hidden opacity-0 float-right"
				/>
				<input type="submit" className="hidden" />
			</form>
		</FormContext.Provider>
	);
};

export default memo(Form);
